// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3hDug","checkboxCol":"Table_checkboxCol__2voDB","emailCol":"Table_emailCol__3o40E","actionCol":"Table_actionCol__2mPft"};